import { isEmpty } from 'lodash';
import React, { ChangeEvent } from 'react';
import { Box, FormControl } from '@mui/material';
import { SPWBaseTextField } from 'spw-shared/globalComponents';
import { MAX_SCENARIO_NAME_LENGTH } from 'spw-constants';
import useUnitConversion from 'spw-components/unit-conversion/hooks';
import { ScenarioNameErrorMessage } from './styles';

interface ScenarioName {
  setScenarioName: (name: string) => void;
  scenarioName: string;
  disabled?: boolean;
  isClosing?: boolean;
}

export const ScenarioName = ({
  setScenarioName,
  scenarioName,
  disabled,
  isClosing,
}: ScenarioName) => {
  const { getUnit } = useUnitConversion();
  const showNameAlreadyInUseError =
    !isEmpty(scenarioName) && disabled && !isClosing;

  return (
    <Box marginBottom={4}>
      <FormControl variant="outlined" fullWidth>
        <SPWBaseTextField
          label="Scenario Name"
          style={{ width: '100%' }}
          onChange={(event: ChangeEvent<HTMLInputElement>) => {
            const { value } = event.target;
            setScenarioName(value);
          }}
          value={scenarioName || ''}
          placeholder={`Ex. Floor 2 ${getUnit('area')} 150`}
          name="Copied Scenario Name"
          inputProps={{ maxLength: MAX_SCENARIO_NAME_LENGTH }}
        />
      </FormControl>
      {showNameAlreadyInUseError && (
        <ScenarioNameErrorMessage>
          Scenario name is already in use.
        </ScenarioNameErrorMessage>
      )}
    </Box>
  );
};
